var accordion = (function() {

  // Aside navigation

  $(".accordion-item").on("click", function(e) {
    if ($(this).attr("aria-expanded") == "true") {
      $(this).attr("aria-expanded", false);
    } else {
      $(this).attr("aria-expanded", true);
    }
    if ($(this).hasClass("active")) {
      $(this)
        .removeClass("active")
        .find("button")
        .attr("aria-expanded", false);
    } else {
      $(".accordion-item")
        .removeClass("active")
        .find("button")
        .attr("aria-expanded", false);
      $(this)
        .addClass("active")
        .find("button")
        .attr("aria-expanded", true);
    }
  });

})();
